import React from 'react'
import { Link } from 'react-router-dom'
import { FaArrowRight } from 'react-icons/fa'
import '../styles/global.css'

const CodeCard = ({ code, title, type, slug, searchCount }) => {
  return (
    <Link
      to={
        type === 'cnae2009'
          ? `/cnae-2009/${code.replace('.', '')}/${slug}`
          : type === 'cnae'
          ? `/cnae-2025/${code.replace('.', '')}/${slug}`
          : type === 'iae'
          ? `/iae/${code.replace('.', '')}/${slug}`
          : `/${type}/${slug}`
      }
      className='bg-surface rounded-md p-4 hover:transform hover:-translate-y-1 transition-all duration-300 hover:shadow-lg flex flex-col h-full'
    >
      <div className='flex justify-between items-start mb-3'>
        <div>
          <div
            className={`inline-block ${
              type === 'iae'
                ? 'bg-iae'
                : type === 'cnae2009'
                ? 'bg-cnae2009'
                : 'bg-cnae'
            } text-background px-2 py-1 rounded text-xs font-extrabold mb-2`}
          >
            {type === 'iae'
              ? 'IAE'
              : type === 'cnae2009'
              ? 'CNAE 2009'
              : 'CNAE 2025'}
          </div>
          <h3 className='text-text-primary text-base font-bold'>{code}</h3>
        </div>
        <FaArrowRight className='text-text-secondary transform -rotate-45' />
      </div>
      <h3 className='text-text-secondary text-base mb-2 font-medium'>
        {title}
      </h3>
      {searchCount && (
        <div className='mt-auto pt-2 text-sm text-text-secondary'>
          {searchCount} búsquedas
        </div>
      )}
    </Link>
  )
}

export default CodeCard
